import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Swiftdzireonrentinmumbai() {



const cardData = {
  keyword: " Swift Dzire on Rent in Mumbai",

headingDescription:
  "Omshree Cab offers reliable and affordable Swift Dzire on rent in Mumbai for travelers looking for comfortable and fuel‑efficient cars for city travel, airport transfers, corporate trips, or weekend getaways. The Swift Dzire is a popular sedan known for its smooth ride, roomy interiors, and excellent mileage, making it an ideal choice for solo travelers, couples, families, and business travelers. With Omshree Cab’s flexible rental options, you can rent the Swift Dzire on a one‑way basis, round trip, hourly package, or full‑day rental with transparent pricing. Our Swift Dzire fleet is regularly serviced, air‑conditioned, and driven by professional chauffeurs who are familiar with Mumbai’s roads, traffic patterns, and pickup/drop locations. With easy booking, punctual pickups from any address in Mumbai (including the airport, railway stations, and hotels), and 24/7 customer support, renting a Swift Dzire in Mumbai becomes a smooth and convenient experience.",

topPlaces: [
  {
    title: "Gateway of India",
    description:
      "Gateway of India is one of Mumbai’s most iconic landmarks located on the waterfront in South Mumbai. Visitors come here to admire the majestic arch, take photographs, and enjoy boat rides to Elephanta Island. The nearby Colaba area offers vibrant street markets, cafes, and historic sites. Renting a Swift Dzire in Mumbai makes it convenient to reach the Gateway of India comfortably, enabling you to explore South Mumbai’s attractions without the hassle of parking or public transport."
  },
  {
    title: "Marine Drive",
    description:
      "Marine Drive is a scenic coastal road along the Arabian Sea, popularly called the Queen’s Necklace because it lights up at night in a necklace‑like pattern. Visitors enjoy sunset views, long evening walks, and serene sea breezes. The road also connects to Nariman Point, Chor Bazaar, and Chowpatty Beach. Renting a Swift Dzire provides a smooth and comfortable ride along this beautiful stretch, ideal for sightseeing and leisurely drives."
  },
  {
    title: "Juhu Beach",
    description:
      "Juhu Beach is one of Mumbai’s most popular beaches, drawing locals and tourists alike for relaxation, seaside food, and sunset views. Visitors come here to enjoy street food like pav bhaji, bhel puri, and chilled coconut water. Renting a Swift Dzire ensures you can reach Juhu Beach easily from anywhere in Mumbai and enjoy a comfortable trip to the coast with flexibility in timing."
  },
  {
    title: "Siddhivinayak Temple",
    description:
      "Siddhivinayak Temple is a revered Hindu temple in Mumbai dedicated to Lord Ganesha. Devotees and visitors travel from all over to seek blessings and participate in rituals. The temple is especially busy during festivals like Ganesh Chaturthi. Renting a Swift Dzire makes it simple to reach the temple conveniently and avoid the challenges of city traffic or parking near this popular spiritual site."
  },
  {
    title: "Bandra Worli Sea Link",
    description:
      "Bandra Worli Sea Link is a modern cable‑stayed bridge connecting Bandra and Worli across the Arabian Sea. The bridge offers breathtaking views of the sea and skyline, especially during sunset and at night when illuminated. Visitors often choose this route for panoramic drives and scenic views. A Swift Dzire rental ensures a comfortable and stylish drive across this architectural marvel, making it a memorable part of your Mumbai visit."
  },
  {
    title: "Haji Ali Dargah",
    description:
      "Haji Ali Dargah is an iconic mosque and tomb located on an islet off the coast of Mumbai. The white marble structure surrounded by the sea attracts visitors from different walks of life who come for prayers and sightseeing. Reaching this landmark can be challenging due to traffic and parking limitations, but renting a Swift Dzire provides a relaxed and hassle‑free journey to this spiritual destination."
  },
  {
    title: "Elephanta Caves",
    description:
      "Elephanta Caves are ancient rock‑cut caves located on Elephanta Island and are famous for their intricate stone carvings dedicated to Lord Shiva. Tourists reach the island by ferry from the Gateway of India and explore the cave temples and scenic surroundings. Renting a Swift Dzire helps you reach the ferry terminal easily and begin your exciting trip to this UNESCO World Heritage Site without any transportation stress."
  },
  {
    title: "Sanjay Gandhi National Park",
    description:
      "Sanjay Gandhi National Park is a large urban forest reserve in Mumbai offering trekking, cycling, nature walks, and historical Kanheri Caves. Nature lovers and families visit this green oasis to enjoy outdoor activities and scenic trails. Renting a Swift Dzire makes it convenient to plan a day trip to the park and explore the natural and historical attractions on your own schedule."
  },
  {
    title: "Colaba Causeway",
    description:
      "Colaba Causeway is a vibrant street in South Mumbai filled with markets, boutiques, cafes, and local vendors. It’s a favorite destination for shoppers and culture enthusiasts. Renting a Swift Dzire ensures a comfortable way to reach this bustling area and spend time shopping or exploring the lively streets without transportation hassles."
  },
  {
    title: "Hanging Gardens",
    description:
      "Hanging Gardens, also called Pherozeshah Mehta Gardens, are terraced green gardens located on Malabar Hill, offering panoramic views of Marine Drive and the Arabian Sea. Visitors come here for peaceful walks, photography, and relaxation. Renting a Swift Dzire provides a comfortable ride to this scenic location, making it easy to include this beautiful garden in your Mumbai sightseeing itinerary."
  }
],



services: [
{
name: "Swift Dzire on Rent Mumbai",
description: "Swift Dzire on rent in Mumbai offers comfortable and economical transportation for passengers traveling within the city or to nearby destinations. The Swift Dzire sedan is known for its smooth ride, spacious interiors, and excellent mileage, making it ideal for daily travel. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for airport transfers, city tours, and business travel. Air-conditioned interiors ensure comfortable journeys for passengers. Flexible booking options allow easy ride scheduling. Reliable Dzire rental services ensure convenient transportation."
},
{
name: "Dzire Cab Service Mumbai",
description: "Dzire cab service in Mumbai provides reliable transportation using comfortable Swift Dzire sedans suitable for city travel and intercity journeys. The vehicle offers spacious seating and smooth driving experience on both city roads and highways. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available across Mumbai including homes, offices, hotels, railway stations, and airport terminals. Ideal for daily commuting, airport transfers, and business travel. Comfortable AC interiors ensure relaxed travel for passengers. Flexible booking options allow quick reservations. Reliable Dzire cab services ensure smooth travel experiences."
},
{
name: "Swift Dzire Taxi Mumbai",
description: "Swift Dzire taxi in Mumbai offers comfortable sedan transportation for passengers seeking reliable travel across the city. The Swift Dzire provides spacious seating and smooth suspension for relaxed journeys. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Mumbai. Ideal for business trips, family travel, and airport transfers. Air-conditioned interiors ensure comfortable rides throughout the journey. Flexible ride scheduling allows easy booking. Reliable Dzire taxi services ensure convenient city transportation."
},
{
name: "Dzire Car Rental Mumbai",
description: "Dzire car rental in Mumbai offers affordable sedan transportation for passengers traveling locally or to nearby destinations. The Swift Dzire sedan is popular for its comfort, fuel efficiency, and smooth driving experience. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for city travel, airport transfers, and outstation trips. Spacious seating ensures comfortable journeys for passengers. Flexible rental options allow convenient booking. Reliable Dzire car rental services ensure smooth transportation."
},
{
name: "Dzire Cab Booking Mumbai",
description: "Dzire cab booking in Mumbai allows passengers to reserve comfortable Swift Dzire sedans quickly and conveniently. Online and phone booking options provide instant ride confirmation. Professional drivers ensure punctual pickup and safe driving throughout the journey. Pickup services are available across Mumbai including homes, offices, hotels, railway stations, and airports. Ideal for business travel, tourism visits, and daily commuting. Air-conditioned interiors ensure comfortable journeys for passengers. Flexible booking options allow easy ride scheduling. Reliable Dzire cab booking ensures smooth transportation."
},
{
name: "Dzire Airport Cab Mumbai",
description: "Dzire airport cab in Mumbai provides reliable airport transportation using comfortable Swift Dzire sedans. The vehicle offers spacious seating and smooth travel for passengers heading to or from the airport. Professional drivers monitor flight timings to ensure punctual pickup and drop services. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for business travelers, tourists, and family travel. Air-conditioned interiors ensure comfortable airport journeys. Flexible booking options allow advance ride reservations. Reliable Dzire airport cab services ensure stress-free travel."
},
{
name: "Dzire Outstation Cab Mumbai",
description: "Dzire outstation cab in Mumbai offers comfortable sedan travel for passengers planning trips outside the city. The Swift Dzire provides smooth highway travel with spacious seating and excellent mileage. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for weekend trips, family vacations, and pilgrimage tours. Comfortable interiors ensure relaxed long-distance journeys. Flexible one-way and round-trip options allow convenient planning. Reliable Dzire outstation cab services ensure smooth travel experiences."
},
{
name: "Dzire One Way Cab Mumbai",
description: "Dzire one way cab in Mumbai provides economical transportation for passengers traveling to their destination without return charges. The Swift Dzire sedan offers comfortable seating and smooth driving experience for intercity travel. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available across Mumbai including homes, offices, hotels, and airport terminals. Ideal for airport transfers, business trips, and tourism visits. Air-conditioned interiors ensure comfortable journeys for passengers. Flexible booking options allow easy ride scheduling. Reliable Dzire one way cab services ensure affordable travel."
},
{
name: "Dzire Taxi Fare Mumbai",
description: "Dzire taxi fare in Mumbai offers transparent pricing for passengers traveling in comfortable Swift Dzire sedans. The sedan provides excellent fuel efficiency and comfortable seating for city travel. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Mumbai. Ideal for daily commuting, airport transfers, and business travel. Comfortable interiors ensure relaxed journeys for passengers. Flexible ride options allow convenient booking. Transparent pricing ensures affordable Dzire taxi travel."
},
{
name: "Cheap Dzire Cab Mumbai",
description: "Cheap Dzire cab in Mumbai offers budget-friendly sedan transportation for passengers seeking economical travel options. The Swift Dzire sedan provides comfortable seating and smooth travel across city roads and highways. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available across homes, offices, hotels, railway stations, and airport terminals in Mumbai. Ideal for students, daily commuters, and budget travelers. Air-conditioned interiors ensure comfortable journeys during travel. Flexible booking options allow convenient ride scheduling. Affordable Dzire cab services ensure economical and reliable transportation."
}
],

tableData: [
["Swift Dzire on Rent Mumbai","Dzire Cab Service Mumbai"],
["Swift Dzire Taxi Mumbai","Dzire Car Rental Mumbai"],
["Dzire Cab Booking Mumbai","Dzire Airport Cab Mumbai"],
["Dzire Outstation Cab Mumbai","Dzire One Way Cab Mumbai"],
["Dzire Taxi Fare Mumbai","Cheap Dzire Cab Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Fuel Efficient & Comfortable Sedan",
    WhyChoosedescription: "The Swift Dzire is one of the most popular sedan cars for rental in Mumbai because of its excellent mileage, smooth ride, and comfortable seating for up to four passengers. It is perfect for city travel, airport transfers, and outstation journeys."
  },
  {
    WhyChooseheading: "Affordable Per KM Pricing",
    WhyChoosedescription: "Omshree Cabs offers competitive pricing for Swift Dzire rentals in Mumbai with transparent per-kilometer rates and clear travel packages so customers know the exact cost before booking." 
  },
  {
    WhyChooseheading: "24/7 Swift Dzire Cab Availability",
    WhyChoosedescription: "Our Swift Dzire rental service in Mumbai is available 24 hours a day. Whether you need an early morning airport drop or late-night pickup, our cabs are always ready to serve."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "All Swift Dzire cars in our fleet are regularly cleaned, sanitized, and maintained to ensure passengers enjoy a comfortable and safe journey."
  },
  {
    WhyChooseheading: "Ideal for Local & Outstation Travel",
    WhyChoosedescription: "Swift Dzire is ideal for both local travel within Mumbai and outstation trips to destinations like Pune, Lonavala, Nashik, Surat, and Shirdi because of its comfort and efficiency."
  },
  {
    WhyChooseheading: "Professional Chauffeur Service",
    WhyChoosedescription: "Our trained drivers are familiar with Mumbai’s roads and traffic patterns. They provide professional and courteous service to ensure a smooth travel experience."
  },
  {
    WhyChooseheading: "Doorstep Pickup Anywhere in Mumbai",
    WhyChoosedescription: "Omshree Cabs offers convenient pickup from homes, hotels, offices, railway stations, and Mumbai Airport so passengers can start their journey without hassle."
  },
  {
    WhyChooseheading: "Reliable Sedan Cab Service",
    WhyChoosedescription: "Many travelers prefer Swift Dzire rentals because the car is compact yet comfortable, making it easy to drive in Mumbai traffic while still offering enough space for passengers and luggage." 
  }
]
};

const faqData = [
  { question: "Is Swift Dzire available on rent in Mumbai?", answer: "Yes, Omshree Cabs provides Swift Dzire car rental services in Mumbai for local travel, airport transfers, and outstation trips." },
  { question: "What is the seating capacity of Swift Dzire?", answer: "Swift Dzire is a 4-seater sedan car suitable for individuals, couples, and small families." },
  { question: "What is the per km rate for Swift Dzire in Mumbai?", answer: "Swift Dzire rental rates in Mumbai usually start around ₹12 to ₹13 per km depending on the travel type and package." },
  { question: "Can I book Swift Dzire for airport pickup and drop?", answer: "Yes, Swift Dzire taxis are commonly used for Mumbai Airport transfers because they provide comfortable seating and luggage space." },
  { question: "Is Swift Dzire suitable for outstation trips?", answer: "Yes, Swift Dzire is widely used for outstation travel from Mumbai due to its fuel efficiency and comfortable ride." },
  { question: "Is the car air-conditioned?", answer: "Yes, all Swift Dzire rental vehicles provided by Omshree Cabs are fully air-conditioned." },
  { question: "Do you provide drivers with the car rental?", answer: "Yes, all Swift Dzire rentals include experienced drivers familiar with Mumbai and highway routes." },
  { question: "Can I book Swift Dzire for full-day local travel?", answer: "Yes, we offer local rental packages such as 8 hours / 80 km or full-day travel within Mumbai." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and peak travel seasons." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain hygiene and passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Desai",
    feedback:
      "We booked a Swift Dzire from Omshree Cabs for our Mumbai airport transfer. The car was clean and the driver arrived on time.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Kulkarni",
    feedback:
      "Very comfortable Swift Dzire ride in Mumbai. Affordable pricing and professional service made our trip very smooth.",
    rating: 5
  }
];




















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Swift Dzire on Rent in Mumbai",
  "description": "Omshree Cab offers Swift Dzire on rent in Mumbai for local travel, airport transfers, outstation trips, and one-way cab services. Affordable fares, easy online booking, and trusted Dzire taxi service across Mumbai.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2600"
  }
};






  return (
    <div>
    <Helmet>
  <title>Swift Dzire on Rent in Mumbai | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab provides Swift Dzire on rent in Mumbai for airport, local, outstation, and one-way trips. Affordable Dzire cab service with easy online booking and trusted taxi service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>
  



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/43.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Swiftdzireonrentinmumbai;